window.iemall_cfg_en = {
  // 页头 topbar
  topbar() {
    return {
      fixed: false,
      is_top: false,
      hidden_nav: true,
      active: -1,
      logo: {
        alt: "iemall",
        url: "/en",
        img: "/img/logo.png",
        img_r: "/img/logo_r.png"
      },
      nav: [
        {
          type: "url",
          url: "/en",
          text: "Home"
        },
        {
          type: "url",
          url: "/en/channel_join",
          text: "Channel joining"
        },
        {
          type: "url",
          url: "/en/business",
          text: "Brand investment"
        },
        {
          type: "url",
          url: "/en/school_1",
          text: "E-commerce"
        },
        {
          type: "url",
          url: "/en/about",
          text: "About"
        },
        {
          type: "button",
          url: "/",
          text: "中文"
        },
        {
          type: "button_default",
          url: "https://myshop.nzmai.com.cn/",
          text: "Login"
        }
      ],
      setup(k, active) {
        if (k) {
          this.fixed = !!k;
          this.is_top = !!k;
        } else {
          this.listener();
        }
        this.active = active;
      },
      listener() {
        var self = this;
        window.addEventListener("scroll", function() {
          self.is_top = document.body.scrollTop > 100 || window.scrollY > 100;
        });
      },
      getLogo() {
        return this.isTop() ? this.logo.img_r : this.logo.img;
      },
      switchNav() {
        this.hidden_nav = !this.hidden_nav;
      },
      isTop() {
        return this.is_top || !this.hidden_nav;
      },
      getLangUrl() {
        return location.pathname.replace(/^\/en/, "") || "/";
      }
    };
  },
  // 页脚 footer
  footer() {
    return {
      logo_img: "/img/logo_f.png",
      copyright: "Copyright © 2019-2020",
      links: [
        {
          name: "Channel joining",
          sub: [
            {
              url: "javascript:;",
              target: "blank",
              name: "Channel advantages"
            },
            {
              url: "javascript:;",
              target: "blank",
              name: "Agency policy"
            },
            {
              url: "javascript:;",
              target: "blank",
              name: "Joining process"
            },
            {
              url: "javascript:;",
              target: "blank",
              name: "Contact"
            }
          ]
        },
        {
          name: "Brand investment",
          sub: [
            {
              url: "javascript:;",
              target: "blank",
              name: "Settlement process"
            },
            {
              url: "javascript:;",
              target: "blank",
              name: "Notice for entry"
            },
            {
              url: "javascript:;",
              target: "blank",
              name: "Shop requirements"
            },
            {
              url: "javascript:;",
              target: "blank",
              name: "Application qualification"
            },
            {
              url: "javascript:;",
              target: "blank",
              name: "Rate standard"
            }
          ]
        },
        {
          name: "E-commerce",
          sub: [
            {
              url: "/en/school_1",
              target: "blank",
              name: "Industry notice"
            },
            {
              url: "/en/school_2",
              target: "blank",
              name: "Warehousing logistics"
            },
            {
              url: "/en/school_3",
              target: "blank",
              name: "Compensation standard"
            },
            {
              url: "/en/school_4",
              target: "blank",
              name: "Service"
            }
          ]
        },
        {
          name: "About",
          sub: [
            {
              url: "/en/about",
              target: "blank",
              name: "About"
            }
          ]
        }
      ]
    };
  },

  // 幻灯页 slide
  slide() {
    return {
      height: "1008px",
      current: 0,
      hasNext: false,
      hasIndicators: false,
      auto: false,
      timer: 5000,
      icon_left_url: "/img/slide/slide_left.png",
      icon_right_url: "/img/slide/slide_right.png",
      data: [{ class: "bg-blue-400", img: "/img/slide/slide_0.png" }],
      heading: ["Honest cooperation", "Mutual benefit and win-win"],
      sub_heading: [
        "Honesty is the bottom line of business cooperation",
        "Qualification certificate is the business card of powerful enterprises"
      ],
      hidden_title_img: true,
      title_img: "/img/slide/title.png",
      title_height: "268px",
      setup() {
        this.height = window.screen.width < 640 ? "640px" : "1008px";
        if (this.auto) {
          this.autoPlay();
        }
      },
      updateCurrent(i) {
        if (this.current == i) return false;
        if (i < 0) i = this.data.length - 1;
        if (i > this.data.length - 1) i = 0;
        this.current = i;
        if (this.auto) {
          this.autoPlay();
        }
      },
      autoPlay() {
        this.autoplayTimer = setTimeout(() => {
          this.updateCurrent(this.current + 1);
        }, this.timer);
      },
      stopAutoPlay() {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    };
  },

  // 入职流程 join
  join() {
    return {
      title: "Joining process",
      divide_img: "/img/step/i_r.png",
      list: [
        {
          type: "one",
          icon: "/img/step/ico_users.png",
          title: "Step1",
          sub: "Register",
          btn: {
            url: "https://agent.nzmai.com.cn/#/application?MTA4NQ%3D%3D",
            name: "Free registration"
          },
          desc:
            'Click "free registration" to register users of iemall business platform'
        },
        {
          type: "one",
          icon: "/img/step/ico_business.png",
          title: "Step2",
          sub: "Apply for residence",
          btn: {
            url: "https://agent.nzmai.com.cn/#/application?MTA4NQ%3D%3D",
            name: "Apply for residence"
          },
          desc:
            "Fill in the information online and upload the qualification documents of electronic documents. Click submit to complete the settlement."
        },
        {
          type: "one",
          icon: "/img/step/ico_files.png",
          title: "Step3",
          sub: "Qualification review",
          btn: {
            url: "https://agent.nzmai.com.cn/#/application?MTA4NQ%3D%3D",
            name: "Progress inquiry"
          },
          desc:
            "After receiving your qualification, we will complete the audit and inform the result within 2 working days."
        },
        {
          type: "two",
          icon: "/img/step/ico_users.png",
          title: "Distribution channel empowerment",
          icon1: "/img/step/ico_done.png",
          title1: "Commission withdrawal"
        }
      ],
      getData() {
        let arr = [];
        for (let i = 0; i < this.list.length; i++) {
          arr.push(this.list[i]);
          if (i != this.list.length - 1) {
            arr.push({
              type: "divide"
            });
          }
        }
        return arr;
      }
    };
  },

  // 图文展示 exhibition
  exhibition() {
    return {
      list: [
        {
          direction: "l",
          bg_color: "#DFEBFB",
          img: "/img/icon_iphone.png",
          img_pos: "right 120px",
          title: "Download IEPay App",
          sub: "Manage your sales channels",
          btns: [
            {
              url: "https://apps.apple.com/nz/app/mypay/id1443437164",
              name: "Download of iPhone",
              icon: "/img/ico_apple.png",
              size: { height: "20px", width: "20px" }
            },
            {
              url: "https://a.mypaynz.com/uploads/app-v2.apk",
              name: "Download of Android",
              icon: "/img/ico_android.png",
              size: { height: "20px", width: "20px" }
            }
          ]
        },
        {
          direction: "r",
          bg_color: "",
          img: "/img/icon_makbook.png",
          img_pos: "left 60px",
          title: "Log in to iemall background now",
          sub: "The goods you sell are on the shelves",
          btns: [
            {
              url: "https://myshop.nzmai.com.cn/",
              name: "Desktop management background",
              icon: "/img/ico_pc.png",
              blank: true,
              size: { height: "20px", width: "20px" }
            },
            {
              url: "https://mshop.nzmai.com.cn/",
              name: "Mobile management background",
              icon: "/img/ico_phone.png",
              blank: true,
              size: { height: "20px", width: "20px" }
            }
          ]
        }
      ],
      getList() {
        if (screen.width < 640) {
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].img = "";
          }
        }
        return this.list;
      }
    };
  },

  // 合作品牌 brand
  brand() {
    return {
      title: "Cooperative brand",
      powered_by_icon: "/img/pharmacy.jpg",
      show_more_size: 13,
      more_text: ["More+"],
      more: true,
      list: [
        {
          name: "Shiseido",
          icon: "/img/brand/Shiseido-Logo.png",
          url: "javascript:;"
        },
        {
          name: "Bayer",
          icon: "/img/brand/bayer.png",
          url: "javascript:;"
        },
        {
          name: "Karicare",
          icon: "/img/brand/Karicare_Toddler.webp",
          url: "javascript:;"
        },
        {
          name: "Geoskincare",
          icon: "/img/brand/Geoskincare.png",
          url: "javascript:;"
        },
        {
          name: "Me Today",
          icon: "/img/brand/Me_Today.png",
          url: "javascript:;"
        },
        {
          name: "Swisse",
          icon: "/img/brand/Swisse-new-logo2-e1576004964752.png",
          url: "javascript:;"
        },
        {
          name: "Thompson's",
          icon: "/img/brand/Thompson's.jpg",
          url: "javascript:;"
        },
        {
          name: "Blackmores",
          icon: "/img/brand/Blackmores.jpg",
          url: "javascript:;"
        },
        {
          name: "Elevit",
          icon: "/img/brand/Elevit.webp",
          url: "javascript:;"
        },
        {
          name: "Oral-B",
          icon: "/img/brand/Oral-B.png",
          url: "javascript:;"
        },
        {
          name: "Ostelin",
          icon: "/img/brand/Ostelin.jpg",
          url: "javascript:;"
        },
        {
          name: "Trilogy",
          icon: "/img/brand/Trilogy.jpg",
          url: "javascript:;"
        },
        {
          name: "Karen Murrell",
          icon: "/img/brand/Karen_Murrell.webp",
          url: "javascript:;"
        },
        {
          name: "Red Seal",
          icon: "/img/brand/Red_Seal.png",
          url: "javascript:;"
        },
        {
          name: "Cemoy",
          icon: "/img/brand/Cemoy.png",
          url: "javascript:;"
        },
        {
          name: "Ugg",
          icon: "/img/brand/Ugg.png",
          url: "javascript:;"
        },
        {
          name: "Antipodes",
          icon: "/img/brand/logo-antipodes.png",
          url: "javascript:;"
        },
        {
          name: "Comvita",
          icon: "/img/brand/Comvita.jpg",
          url: "javascript:;"
        },
        {
          name: "A2",
          icon: "/img/brand/A2.png",
          url: "javascript:;"
        },
        {
          name: "Anchor",
          icon: "/img/brand/anchor-logo.jpg",
          url: "javascript:;"
        },
        {
          name: "Go Healthy",
          icon: "/img/brand/Go_Healthy.png",
          url: "javascript:;"
        },
        {
          name: "Merino",
          icon: "/img/brand/Merino.jpg",
          url: "javascript:;"
        },
        {
          name: "Life Space",
          icon: "/img/brand/Life_Space.png",
          url: "javascript:;"
        },
        {
          name: "Clinicians",
          icon: "/img/brand/Clinicians-logo_Lge.jpg",
          url: "javascript:;"
        },
        {
          name: "Bioisland",
          icon: "/img/brand/bio-island-logo-vector.png",
          url: "javascript:;"
        },
        {
          name: "NutraLife",
          icon: "/img/brand/NutraLife.jpg",
          url: "javascript:;"
        },
        {
          name: "The Good Vitamin Co.",
          icon: "/img/brand/The_Good_Vitamin.webp",
          url: "javascript:;"
        },
        {
          name: "Lancome",
          icon: "/img/brand/Lancome-Logo.png",
          url: "javascript:;"
        },
        {
          name: "Clinique",
          icon: "/img/brand/Clinique.png",
          url: "javascript:;"
        },
        {
          name: "MitoQ",
          icon: "/img/brand/MitoQ_logo_600.webp",
          url: "javascript:;"
        },
        {
          name: "Elizabeth Arden",
          icon: "/img/brand/Elizabeth_Arden.webp",
          url: "javascript:;"
        },
        {
          name: "Kiehl's",
          icon: "/img/brand/Kiehls.jpg",
          url: "javascript:;"
        }
      ],
      getSize() {
        return document.body.offsetWidth > 370
          ? "180px"
          : document.body.offsetWidth > 300
          ? "150px"
          : document.body.offsetWidth / 2 - 10 + "px";
      },
      showMore() {
        if (this.more) this.more = false;
      }
    };
  },

  // channel_img_bg
  channel_img_bg() {
    return {
      bg: "/img/bg_channnel_join.png",
      title: "Make cross border business easier",
      sub:
        "One stop cross border e-commerce system of New Zealand and Macao, making your cross-border business easy"
    };
  },

  // 渠道优势 advantage
  advantage() {
    return {
      title: "Channel advantages",
      active: 0,
      data: [
        {
          title: "Cross border advantages",
          icon: "/img/advantage/ico_kjys.png",
          icon_a: "/img/advantage/ico_kjys_a.png",
          img: "/img/advantage/bg_kjys.png",
          desc: [
            "Health, beauty, quality life,",
            "New Zealand, Japan and South Korea,",
            "The advantage of origin differentiation provides high market competitiveness."
          ]
        },
        {
          title: "Online purchase, sale and storage",
          icon: "/img/advantage/ico_zxjxc.png",
          icon_a: "/img/advantage/ico_zxjxc_a.png",
          img: "/img/advantage/bg_zxjxc.png",
          desc: [
            "On behalf of the sale of goods, the mall orders,",
            "Automatic shipment, logistics tracking,",
            "Automatic calculation of profit distribution throughout the process, sales management is clear at a glance."
          ]
        },
        {
          title: "No official service is required",
          icon: "/img/advantage/ico_kf.png",
          icon_a: "/img/advantage/ico_kf_a.png",
          img: "/img/advantage/bg_kf.png",
          desc: [
            "You don't have to pack and ship,",
            "All overseas products are officially shipped from the place of origin with unified after-sales service,",
            "Lightweight operation management focuses on marketing."
          ]
        },
        {
          title: "Integration of online and offline channels",
          icon: "/img/advantage/ico_qdrh.png",
          icon_a: "/img/advantage/ico_qdrh_a.png",
          img: "/img/advantage/bg_qdrh.png",
          desc: [
            "Online retail, offline wholesale,",
            "All sales mode platform integration,",
            "The advantages of new retail and traditional channels should be utilized at the same time."
          ]
        }
      ],
      getActive() {
        return this.data[this.active];
      },
      setActive(key) {
        this.active = key;
      },
      getIcon(key) {
        return this.active == key ? this.data[key].icon_a : this.data[key].icon;
      }
    };
  },

  // 经销商 agency
  agency() {
    return {
      data: [
        {
          direction: "right",
          height: "696px",
          bg_img: "/img/bg_agency1.png",
          title: "Provincial distributors",
          sub: "Agency policy",
          content: [
            {
              title: "Franchise requirements",
              desc: [
                "Have high market operation ability, can operate a provincial market.",
                "Have the ability of channel expansion and management, and be able to cover the channels to counties and cities with better conditions.",
                "Good understanding of franchise products.",
                "Responsible for the market and channel construction within the local area as agreed in the contract.",
                "Have legal personality.",
                "Have the ability to complete tasks in the region.",
                "The area of Franchise Exhibition Hall shall not be less than 300 m2",
                "The franchise fee is RMB 9 million."
              ]
            },
            {
              title: "Franchise policy",
              desc: [
                "There is no need to press goods, no need to invest in after-sales service, each single sales have a fixed income, complete the task to obtain the corresponding market funding reward.",
                "The general agent has the right to develop subordinate agents and retail agents in the authorized area, and the agents in the original area are under the management of the authorized superior general agent.",
                "If the sales amount stipulated in the dealer agreement is completed for three consecutive years, the franchise fee can be fully refunded."
              ]
            }
          ]
        },
        {
          direction: "left",
          height: "673px",
          bg_img: "/img/bg_agency2.png",
          title: "City level dealers",
          sub: "Agency policy",
          content: [
            {
              title: "Franchise requirements",
              desc: [
                "Have high market operation ability, can operate a provincial market.",
                "Have the ability of channel expansion and management, and be able to cover the channels to counties and cities with better conditions.",
                "Good understanding of franchise products.",
                "Responsible for the market and channel construction within the local area as agreed in the contract.",
                "Have legal personality.",
                "Have the ability to complete tasks in the region.",
                "The area of Franchise Exhibition Hall shall not be less than 200 m2",
                "The franchise fee is 4.5 million RMB."
              ]
            },
            {
              title: "Franchise policy",
              desc: [
                "There is no need to press goods, no need to invest in after-sales service, each single sales have a fixed income, complete the task to obtain the corresponding market funding reward.",
                "The general agent has the right to develop subordinate agents and retail agents in the authorized area, and the agents in the original area are under the management of the authorized superior general agent.",
                "If the sales volume specified in the dealer agreement is completed for 4 consecutive years, the franchise fee can be fully refunded."
              ]
            }
          ]
        },
        {
          direction: "right",
          height: "718px",
          bg_img: "/img/bg_agency3.png",
          title: "County level dealers",
          sub: "Agency policy",
          content: [
            {
              title: "Franchise requirements",
              desc: [
                "Have high market operation ability, can operate a provincial market.",
                "Have the ability of channel expansion and management, and be able to cover the channels to counties and cities with better conditions.",
                "Good understanding of franchise products.",
                "Responsible for the market and channel construction within the local area as agreed in the contract.",
                "Have legal personality.",
                "Have the ability to complete tasks in the region.",
                "The area of Franchise Exhibition Hall shall not be less than 100 m2",
                "The franchise fee is 2.7 million RMB."
              ]
            },
            {
              title: "Franchise policy",
              desc: [
                "There is no need to press goods, no need to invest in after-sales service, each single sales have a fixed income, complete the task to obtain the corresponding market funding reward.",
                "The general agent has the right to develop subordinate agents and retail agents in the authorized area, and the agents in the original area are under the management of the authorized superior general agent.",
                "If the sales volume specified in the dealer agreement is completed for 4 consecutive years, the franchise fee can be fully refunded. "
              ]
            }
          ]
        }
      ],
      eg:
        "For example: District and county level distributors use the platform to sell New Zealand original A2 milk powder, with a can of ￥ 200, a carton of 6 cans of original carton packaging, and an annual sales of 16700 boxes, with an annual sales profit of 2 million yuan and a market funding award of 400000 yuan, with a total annual gross profit of 2.4 million yuan."
    };
  },

  // Contact contact
  contact() {
    return {
      title: "Contact us",
      sub:
        "If you are interested in becoming our partner, we will be happy to hear your voice. Please leave your contact information and let us give you the accounting scheme.",
      desc: []
    };
  },

  // Get in touch in_touch
  in_touch() {
    return {
      title: "",
      height: "381px",
      bg: "/img/bg_getintouch.png",
      from: {
        controls: [
          {
            type: "text",
            name: "name",
            placeholder: "Full name"
          },
          {
            type: "text",
            name: "email",
            placeholder: "Email"
          },
          {
            type: "text",
            name: "message",
            placeholder: "Message"
          },
          {
            type: "button",
            name: "Send"
          }
        ]
      }
    };
  },

  // 品牌招商  business_img_bg
  business_img_bg() {
    return {
      height: "768px",
      bg: "/img/bg_ptys.png",
      title: "Platform advantages",
      sub:
        "Provide cross border e-commerce integration solutions for suppliers",
      list: [
        {
          title: "Cross border E-commerce<br>Supply chain platform",
          icon: "/img/global.png",
          desc: [
            "Platform: zero cost for overseas businesses to settle in.",
            "Display: the page of independent national pavilion, showing brands and commodities accurately",
            "Process: self service or managed goods and orders"
          ]
        },
        {
          title: "Cross border E-commerce",
          icon: "/img/global.png",
          desc: [
            "Mode: fully support cross-border bonded, cross-border direct mail, express channel."
          ]
        },
        {
          title: "Cross border settlement",
          icon: "/img/global.png",
          desc: [
            "Functions: to provide suppliers with multi currency payment settlement functions such as RMB, foreign currency, etc"
          ]
        },
        {
          title: "Resource advantages",
          icon: "/img/global.png",
          desc: [
            "There are restrictions on the number of merchants and resource requirements for brand entry, so as to ensure that brand merchants have enough booth exposure, traffic introduction and sales transformation."
          ]
        }
      ],
      setup() {
        this.height = window.screen.width < 640 ? "640px" : "768px";
      }
    };
  },

  // 品牌招商  business_cooperate
  business_cooperate() {
    return {
      height: "700px",
      bg: "/img/bg_yqhz.png",
      title: "Invite cooperation",
      sub: "Seeking strategic partnership in good faith",
      table: [
        [
          {
            type: "th",
            text: "Settled businesses",
            cls: "font-bold bg-teal-200",
            bg: "#D5EDF9"
          },
          {
            type: "td",
            text: "New Zealand brand matchmaker",
            colspan: 2,
            cls: "text-left bg-teal-200",
            bg: "#D5EDF9"
          }
        ],
        [
          {
            type: "th",
            text: "Enterprise qualification requirements",
            rowspan: 2,
            cls: "font-bold bg-teal-200",
            bg: "#D5EDF9"
          },
          {
            type: "td",
            text: "New Zealand brand supplier · company",
            cls: "text-left bg-teal-100",
            bg: "#E4F5FD"
          },
          {
            type: "td",
            text: "",
            list: [
              "List of products available",
              "Certificate of registered trademark",
              "Quality inspection report",
              "Report on RMP products regulated by the Ministry of primary industry such as milk powder and honey"
            ],
            cls: "text-left bg-teal-100",
            bg: "#E4F5FD"
          }
        ],
        [
          {
            type: "td",
            text:
              "Authorized brand merchants, companies and cooperative brand introducers",
            cls: "text-left bg-teal-100",
            bg: "#E4F5FD"
          },
          {
            type: "td",
            text: "",
            list: [
              "List of products available",
              "Brand authorization document",
              "Quality inspection report of local Commodity Inspection Bureau, manufacturer or third party"
            ],
            cls: "text-left bg-teal-100",
            bg: "#E4F5FD"
          }
        ]
      ]
    };
  },

  // 品牌招商  business_flow
  business_flow() {
    return {
      title: "Iemall business settlement process",
      btn: {
        href: "/en/register",
        text: "Apply for residence"
      },
      divide_img: "/img/step/i_r.png",
      list: [
        {
          type: "box",
          icon: "/img/ico_file.png",
          title: "Submit settlement information",
          sub: "About 2 hours",
          desc: [
            "Select store type / brand / category",
            "Fill in brand information",
            "Fill in enterprise information",
            "Shop name"
          ]
        },
        {
          type: "box",
          icon: "/img/ico_time.png",
          title: "Business waiting for audit",
          sub: "About 7 working days",
          desc: ["Brand evaluation", "Qualification review"]
        },
        {
          type: "box",
          icon: "/img/ico_tick.png",
          title: "Finish shop preparation",
          sub: "About 1 day",
          desc: [
            "Activate the merchant account and log in",
            "Sign the agreement and lock in the margin",
            "Shop name"
          ]
        },
        {
          type: "box",
          icon: "/img/ico_store.png",
          title: "Shop officially launched",
          sub: "",
          desc: ["Release merchandise and decorate shop"]
        }
      ],
      getData() {
        let arr = [];
        for (let i = 0; i < this.list.length; i++) {
          arr.push(this.list[i]);
          if (i != this.list.length - 1) {
            arr.push({
              type: "divide"
            });
          }
        }
        return arr;
      }
    };
  },

  // 跨境商学院 school_main
  school_main() {
    return {
      data: [
        {
          direction: "r",
          img_url: "/img/school/chess.png",
          align: false,
          width: "360px",
          height: "240px",
          cls: "bg-gray-100",
          title: "",
          desc_size: "",
          desc: [
            "Iemall products were launched in July 2018. As of May 2020, 138 businesses have settled in and 741 stores have been established. Iepay business has focused more and more on local small and medium-sized merchants, and Chinese consumers are also a huge consumer market in terms of geographical attributes of payment channels. We have been committed to creating a broader business platform for small and medium-sized businesses in New Zealand to produce",
            "Iemall's existing merchants and local small and medium-sized brand merchants in New Zealand have very New Zealand products. They need to promote the products to China. However, due to the problems of enterprise scale, understanding of the Chinese market, transportation, payment and so on, many merchants are unable to expand the Chinese market. They are eager to have a platform to help them expand the Chinese market. Based on the payment channels and merchants, iepay has designed an IE cross-border strict selection platform to break through regional barriers for local small and medium-sized brand merchants and Chinese consumers, and realize wireless links."
          ]
        },
        {
          direction: "l",
          img_url: "/img/school/tu_1.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "",
          title: "Chaoyang industry takes the lead",
          desc_size: "text-sm",
          desc: [
            "Iemall's existing merchants and local small and medium-sized brand merchants in New Zealand have very New Zealand products. They need to promote the products to China. However, due to the problems of enterprise scale, understanding of the Chinese market, transportation, payment and so on, many merchants are unable to expand the Chinese market. They are eager to have a platform to help them expand the Chinese market. Based on the payment channels and merchants, iepay has designed an IE cross-border strict selection platform to break through regional barriers for local small and medium-sized brand merchants and Chinese consumers, and realize wireless links."
          ]
        },
        {
          direction: "r",
          img_url: "/img/school/tu_2.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "bg-gray-100",
          title: "Steady growth, faster and stronger",
          desc_size: "text-sm",
          desc: [
            "Iemall's existing merchants and local small and medium-sized brand merchants in New Zealand have very New Zealand products. They need to promote the products to China. However, due to the problems of enterprise scale, understanding of the Chinese market, transportation, payment and so on, many merchants are unable to expand the Chinese market. They are eager to have a platform to help them expand the Chinese market. Based on the payment channels and merchants, iepay has designed an IE cross-border strict selection platform to break through regional barriers for local small and medium-sized brand merchants and Chinese consumers, and realize wireless links."
          ]
        },
        {
          direction: "l",
          img_url: "/img/school/tu_3.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "",
          title: "Market space continues to expand",
          desc_size: "text-sm",
          desc: [
            "iIemall's existing merchants and local small and medium-sized brand merchants in New Zealand have very New Zealand products. They need to promote the products to China. However, due to the problems of enterprise scale, understanding of the Chinese market, transportation, payment and so on, many merchants are unable to expand the Chinese market. They are eager to have a platform to help them expand the Chinese market. Based on the payment channels and merchants, iepay has designed an IE cross-border strict selection platform to break through regional barriers for local small and medium-sized brand merchants and Chinese consumers, and realize wireless links."
          ]
        },
        {
          direction: "r",
          img_url: "/img/school/tu_4.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "bg-gray-100",
          title:
            "Customs clearance layout is the pain point of offline store layout, which is our advantage",
          desc_size: "text-sm",
          desc: [
            "iIemall's existing merchants and local small and medium-sized brand merchants in New Zealand have very New Zealand products. They need to promote the products to China. However, due to the problems of enterprise scale, understanding of the Chinese market, transportation, payment and so on, many merchants are unable to expand the Chinese market. They are eager to have a platform to help them expand the Chinese market. Based on the payment channels and merchants, iepay has designed an IE cross-border strict selection platform to break through regional barriers for local small and medium-sized brand merchants and Chinese consumers, and realize wireless links."
          ]
        },
        {
          direction: "l",
          img_url: "/img/school/tu_5.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "",
          title:
            "Industry leaders, embrace technological change, continue micro customer service to provide better service!",
          desc_size: "text-sm",
          desc: [
            "iIemall's existing merchants and local small and medium-sized brand merchants in New Zealand have very New Zealand products. They need to promote the products to China. However, due to the problems of enterprise scale, understanding of the Chinese market, transportation, payment and so on, many merchants are unable to expand the Chinese market. They are eager to have a platform to help them expand the Chinese market. Based on the payment channels and merchants, iepay has designed an IE cross-border strict selection platform to break through regional barriers for local small and medium-sized brand merchants and Chinese consumers, and realize wireless links."
          ]
        }
      ]
    };
  },

  // 跨境商学院 school_other
  school_other() {
    return {
      school_1: [
        {
          question:
            "If the company does not have products, can I take the products to the company for delivery?",
          answer: [
            "At present, the platform only supports the unified purchase of purchased products by the sales product department, and temporarily does not support the sales of products owned by the person in charge of the website. If the product price is really good, you can contact customer service to declare new product recommendation. If all aspects are suitable, special personnel will contact you for confirmation. In addition, with the development of the platform, it will be optimized in all aspects in the future, please look forward to it."
          ]
        },
        {
          question:
            "Why is the local price in New Zealand higher than that in China?",
          answer: [
            "The local sales of products in New Zealand are subject to tax, that is, GST increased by a part compared with that exported to China",
            "If the order is sent to China by mail, the price is RMB or New Zealand dollar, excluding tax.",
            "People in New Zealand need to express to New Zealand local or users to the company to pick up, the use is New Zealand dollars or RMB tax inclusive price.",
            "If you want to view it in the background, you can log in to 188 background and select the price including tax and price excluding tax."
          ]
        },
        {
          question:
            "I have a physical store to purchase goods from the platform and sell it in my own store?",
          answer: [
            "This behavior is not allowed. All products of the platform come to China by direct mail. At present, they follow the postal law, rather than import through general trade. There is no tax paid for the products in China, and the relevant domestic entities are not allowed to sell them. Therefore, offline sales are illegal.",
            "You prepare some samples and hold some activities to let customers experience and try them out. This is not sales. Don't worry about it.",
            "Therefore, we recommend that you arrange samples in the physical store for customers to experience on site, and then introduce the customers to place orders through the platform and take the guests as the final recipients. The whole process is completed through the website platform to make the sales behavior reasonable and compliant.",
            "It should be noted that: each person in China only has a direct mail delivery volume of no more than 20000 yuan per year. If it exceeds the amount, it is easy to be spot checked by the Customs record, which will affect the customs clearance of other normal trade products and your personal reputation. Therefore, if the quantity of just needed products such as milk powder is relatively large, it is suggested that guests use the information of their families to purchase."
          ]
        },
        {
          question: "How does the platform ensure the authenticity?",
          answer: [
            "① We have CCIC small package certification, which is the only trace to the package in the world, so that customers can trace the whole package situation.",
            "② Overseas direct mail, to ensure that products directly from the warehouse to the user's hands.",
            "③ Overseas warehouse real-time monitoring, so that the user's package has never been out of the warehouse to start the whole live broadcast.",
            "④ A letter of authorization issued directly by the manufacturer to prove the source of our products.",
            "⑤ Milk powder follows the strict RMP system, directly from the logistics warehouse with RMP authority to ensure the product quality."
          ]
        },
        {
          question:
            "Why overseas shopping is not the reason for cross-border e-commerce?",
          answer: [
            'Overseas shopping" is a rising trend of online shopping consumption in recent years. It refers to that consumers do not rely on purchasing agents, but go directly to the overseas (Overseas) online shopping. The main body of "overseas shopping" is individuals, and the main body of cross-border e-commerce is qualified enterprises. In terms of legal effect, enterprises are safer and more reliable than individuals. Cross border e-commerce enterprises send goods from overseas to China through centralized overseas procurement. Because cross border e-commerce is generally concentrated overseas procurement, or sellers of foreign brands, it has great advantages in terms of price. Therefore, in terms of the above two aspects, cross-border e-commerce has great advantages over overseas online shopping. Cross border e-commerce and overseas shopping are totally different things. If we grasp the core points above, we can basically distinguish them.'
          ]
        },
        {
          question: "Overseas warehouse must be in origin, why?",
          answer: [
            "The overseas warehouse can ensure that 100% of the goods come from overseas, and fundamentally avoid the appearance of fake goods. Magic lamp is a cross-border e-commerce mode with 100% overseas direct purchase and self-management and direct mail collection from the origin. At present, magic light has opened overseas warehouses in Auckland, Australia and Dusseldorf in Germany. With the expansion of the company's market, more overseas warehouses are under construction. Please look forward to it."
          ]
        },
        {
          question: "What is export and cross-border e-commerce?",
          answer: [
            "Cross border e-commerce refers to an international business activity in which trading entities belonging to different customs areas reach transactions, make payment and settlement through e-commerce platform, and deliver goods and complete transactions through cross-border logistics."
          ]
        },
        {
          question:
            "There are many similar purchasing platforms. What are the advantages of our platform?",
          answer: [
            "Most of the e-commerce companies can only purchase, that is to say, you can appear as a customer, buy goods, send goods to the other party, store goods and sell them. As time goes on, you will find that the more you do, the more difficult it will be. The more questions the customers have, the more they want to cry, and they will work for 8 hours a day. If your customer asks you about the products for half an hour, you can only answer 16 customers a day, and it may not be successful Orders and sales."
          ]
        },
        {
          question: "Our strengths:",
          answer: [
            "With the same time, space and personnel, our 3.0 sales system can help you infinitely enlarge the fixed time and share it through 188 background distribution. If you persevere, it is not impossible to reach tens of millions of people in the same period of time. Imagine, three months after joining us in the morning, I opened my eyes, picked up my mobile phone and opened the background of 188. NZ, and I entered the scene of e-wallet income. Wow, that mood, not to mention how wonderful ~"
          ]
        },
        {
          question: "Powerful background functions:",
          answer: [
            "ØWebsite editor",
            "ØEdit website information, upload logo, contact information and QR code",
            "ØWallet management",
            "ØMulti currency profit management, account details query",
            "ØDistribution management",
            "ØManage your own distribution network and build your own sales team",
            "ØCommodity management",
            "ØClearly see the price, weight and inventory of each product",
            "ØOrder management",
            "ØQuery the status, logistics and profit of each order easily",
            "Øcustomer management",
            "ØGrade customers, bid farewell to tedious quotation, and deal with a large number of customers easily"
          ]
        }
      ],
      school_2: [
        {
          question: "How to calculate the freight weight?",
          answer: [
            "According to the delivery warehouse information,",
            " · New Zealand warehouse products and Australia warehouse products: one kilogram single warehouse, single package, ordinary line.",
            " · If the genuine product is full of one kilogram, the free gift will be sent by parcel.",
            " · If the genuine product is not full of one kilogram, the gift will not collect the weight.",
            " · If the product purchased is not full of one kilogram, it shall be paid according to the difference.",
            " · For example, if the weight of products a and B are a300g and b400g respectively, the freight is calculated according to the weight of (1 - (a + b)), that is, 1 - (0.3 + 0.4) = 0.3 (kg). If the customer's order does not include other products of B, the final freight is 0.3 * freight."
          ]
        },
        {
          question: "Who should I contact for after-sales problems?",
          answer: [
            "You can contact our online customer service directly",
            " · Working hours are:",
            " · Beijing time weekdays winter time: 5:00 a.m. to 22:00 p.m. (summer time: 4:00 to 21:00 p.m.)",
            " · Weekend 8:00 to 17:00, in case of holidays, according to the holiday adjustment, the backstage will notice separately.",
            " · contact information: cs@miepay.com"
          ]
        },
        {
          question:
            "Capsule class, soft candy kind health care product and lipstick, after arrival may have adhesion, soften or dissolve the situation, how to deal with?",
          answer: [
            "Due to the different seasons in China, New Zealand and Australia, due to the weather, the product melts, which is an uncontrollable factor. If you keep it in the refrigerator and peel it carefully, it will not affect the use. It is best to put the liquid health care products in the refrigerator for refrigeration."
          ]
        },
        {
          question: "How to deal with the damage after arrival?",
          answer: [
            "Direct mail products due to long-distance transport pressure changes and rapid changes in temperature and domestic logistics violence and other reasons.",
            "There may be damage, please check with the express in person and leave the express written instructions.",
            "If unable to provide instructions, please take clear pictures of damaged products, packaging, packing boxes, express bills, etc., and contact customer service as soon as possible.",
            "(see compensation policy for details)."
          ]
        },
        {
          question: "How long is the time limit for customs clearance?",
          answer: [
            "The time limit for customs clearance refers to the time from the beginning of customs clearance to customs clearance. The specific time limit depends on the work efficiency of customs staff. There is no way to give a specific time guarantee. The time limit for customs clearance of different products will be different.",
            "Generally speaking, the clearance time of health products is about 2-4 weeks.",
            "Because milk powder is a powder product, the clearance time will be a little longer, about 4-8 weeks",
            "If there is an inspection, it may take a little longer."
          ]
        },
        {
          question:
            "Can I buy the package products together with other products? Are other products also included?",
          answer: [
            "We can place orders with other products.",
            "The package product itself is free shipping.",
            "However, other products ordered together need to be calculated separately according to the current freight policy"
          ]
        },
        {
          question:
            "Why is New Zealand's milk powder delivery cycle particularly long?",
          answer: [
            "Reasons for customs clearance",
            "Milk powder is a powder product, and customs clearance will be slower than that of general health care products.",
            "New Zealand's unique RMP system process is more rigorous.",
            "According to the law of New Zealand (animal products act, 1999), only registered exporters are qualified to export dairy products. The New Zealand agriculture and Forestry Bureau strictly checks the relevant qualifications of dairy operators. According to the requirements of the New Zealand agriculture and Forestry Bureau, all processes of dairy products from milk source to factory transportation, including vehicles and warehouses used for transportation, must comply with RMP specifications and be subject to the supervision of the Ministry of agriculture and forestry. If the dairy product is separated from any part of the safety chain, it will be regarded as not conforming to the RMP specification and the product will not be exported"
          ]
        },
        {
          question:
            "What does customs inspection (second customs clearance) mean? How long will it be?",
          answer: [
            "Inspection refers to a kind of supervision mode in which the customs accepts the declaration from the customs declaration unit and has already examined and verified the declaration unit to determine whether the contents of the declaration documents are consistent with the actual import and export goods through the actual verification of the export goods. In short, inspection is equivalent to a new customs clearance.",
            "Inspection will slightly extend the customs clearance time of the package, which is about one month from the beginning of inspection."
          ]
        },
        {
          question:
            "Milk powder and health care products can be placed together?",
          answer: [
            "Milk powder and health products, food products can be placed together.",
            "However, infant milk powder is limited and can only be transported separately",
            "If you buy adult milk powder, it may be sent out together with health care products."
          ]
        },
        {
          question: "Why my ID card upload is not successful, how to do?",
          answer: [
            "Failed to upload ID card. The solution is different according to different bin.",
            "At present, the logistics of common products of warehouses in New Zealand and Australia is xinshunfeng logistics. If the ID card fails to upload, the logistics will handle it according to the following process: some customers write wrong names, fail to upload the ID card in time, the validity period is less than three months, the photos are not clear, and the quality of the uploaded ID card is not up to standard, so the logistics may use the name of its employees to help customs clearance (repair) But the receiving phone number and address, as well as the products in the package are correct, which is also to enable the package to clear customs as soon as possible. Please sign for it and do not reject it. That is, the package will be sent out, but the name may be changed. Generally, the telephone number and address will not be changed. Need to open to check whether the product is corresponding, if not, keep the face sheet and product photos, contact customer service in time, and handle the compensation procedures.",
            "New Zealand warehouse milk powder products will be sent to random logistics, specific ID card upload situation, if there is a problem, you need to contact customer service.",
            "ID card number, must ensure that no more than 20000 RMB import goods purchase quota. If there is more than, the customer service will contact the customer and provide the real and valid ID card number of other people, otherwise it may lead to the failure of customs clearance."
          ]
        },
        {
          question:
            "New Zealand Australia (Germany) direct mail products need to upload ID card?",
          answer: [
            "Yes, it is. Shipment from New Zealand and Australia will default to new SF international logistics. After placing an order, please go to the official website of new SF international logistics www.nsf.co.nz Or add wechat public account NSF_ Ex upload Chinese mainland name. Please ensure that the name of the uploaded document is identical with the name of the recipient. (logistics only means the mainland China identity card. If it is a foreigner or a resident of Hongkong, please change the name of the addressee and upload the ID card information). German warehouse delivery needs to check the specific instructions of the front desk. Different products need different information. When placing an order, you need to fill in the correct and valid ID card number of the recipient. If you fill in the wrong first time, you need to contact customer service to provide ID card photo + number for the second time.ID card number, must ensure that no more than 20000 RMB import goods purchase quota. If there is more than, the customer service will contact the customer and provide the real and valid ID card number of other people, otherwise it may lead to the failure of customs clearance."
          ]
        }
      ],
      school_3: [
        {
          question: "Scope of compensation:",
          answer: [
            "1. Compensation for milk powder:",
            "In the process of transportation caused by the explosion of milk powder can not eat, give full compensation; due to the long journey, it is difficult to control the phenomenon of pot collapse, so it is not within the scope of compensation.",
            "2. Compensation for honey products:",
            "If the cap is damaged and does not affect the consumption, the minimum compensation standard (20%) will be given according to the actual situation.",
            "In case of side leakage or damage, compensation shall be made according to the proportion of leakage according to the actual situation. If it is completely damaged, that is, it can not be eaten, full compensation will be given.",
            "3. Compensation for liquid products:",
            "In case of any damage, that is, if it is not edible, full compensation shall be made, but no compensation shall be made for the contamination of other products due to liquid spillage; in case of leakage detection or minor damage, compensation shall be made according to the proportion of leakage of the goods according to the actual situation.",
            "4.If other products are completely damaged and cannot be eaten, compensation shall be made according to the price; if the bottle cap is damaged and does not affect the consumption, the minimum compensation standard (20%) shall be paid according to the actual situation.",
            "5. Due to weather, temperature difference and other force majeure, quality changes caused by health care products, cosmetics, please contact customer service, as appropriate compensation.",
            "6. Some foods with special packaging, such as potato chips, salt, pasta, milk flakes, biscuits and chocolate, are not within the scope of compensation due to their special packaging and easy damage.",
            "7. If the delivery can not be delivered in time due to the recipient's unclear filling, wrong telephone number, wrong address or unreasonable rejection by the customer, if it can not be delivered to the customer after the second delivery, it is not within the scope of compensation (the secondary delivery fee generated shall be paid by the recipient).",
            "8. Compensation time limit: in order to improve the efficiency of our compensation, please contact us in time after finding problems, and provide the express bill number and photos of damaged packages as evidence.",
            "9. Limit of compensation amount: for any lost parts, full compensation will be given for the price and freight of the goods. If the value of a single parcel is higher than $250, the maximum amount of compensation is $250",
            "10. For all compensation applications, the sender must provide the damaged pictures of the compensation items, the pictures of the logistics packing boxes and the pictures of the express bills. If not, no compensation will be made."
          ]
        },
        {
          question: "Compensation process:",
          answer: [
            "1. Be sure to check and sign on the spot. Do not reject the package. Do not let the guard, security guard or friends collect the package. If the damage within the scope of compensation (refer to the compensation scope) is found in the on-site inspection, it is necessary to verify with the courier in person and ask the courier to state the situation on the bottom sheet. The recipient must keep the original order, take photos within 2 working days after receiving the goods, and contact the customer service in time. If the time limit is exceeded or the damaged pictures cannot be provided comprehensively, no compensation will be made.",
            "Content: name and quantity of damaged products, package with express sheet pictures, and clear pictures of damaged products (if there are multiple damaged products, please take photos individually and then take photos together).",
            "2.If the delivery courier refuses to inspect the goods, please sign for it first. After signing in, if you find any product compensation problem within the scope of compensation (refer to the compensation scope), please contact customer service in time according to the damage compensation format within 2 working days after receiving the goods.",
            "3. For all compensation recipients, they should contact customer service in time to apply for claim settlement within 2 working days after signing",
            "4.If we follow the above compensation process, we will contact logistics for compensation as soon as possible. After compensation, we will give feedback immediately and refund after negotiation and confirmation by both parties. Note: compensation for damage occurred in logistics will not accept any compensation on the ground that it cannot be sold again (the compensation basis is whether the use or consumption is affected)."
          ]
        }
      ],
      school_4: [
        {
          question: "How to make your own profit?",
          answer: [
            "The profit of the order, after the user completes the order and the product is actually delivered, the background will automatically settle the profit and automatically transfer the corresponding amount into the E-wallet. But when the amount of the electronic wallet reaches RMB 250 or NZD / AO 50 yuan, it can make cash withdrawals, and withdraw profits to Alipay or bank cards."
          ]
        },
        {
          question: "To whom is the order refunded?",
          answer: [
            "There are two cases",
            "1、 Beijing time on April 17, 2019 at 11:30, RMB payment order refund can be returned the same way",
            "Instructions on returning the original route:",
            "1.The order must be a non payment out of RMB payment order (only for WeChat website or Alipay payment, small order payment).",
            "2.In other cases, the money will still be returned to the E-wallet in the background for orders paid in other circumstances (e.g. bank transfer payment on the website and payment on the website Polypay) and refund of orders that have been issued",
            "3.All orders paid before 11:30 Beijing time on April 16, 2019 will still be refunded to the backstage e-wallet ",
            "2. If a refund is generated after the order has been delivered successfully, the refund will be returned to the 188 e-wallet of the ordering website."
          ]
        },
        {
          question: "How do end customers pay?",
          answer: [
            "At present platform supports the most mainstream Alipay or WeChat payment, if you need bank card payment, you can bind the bank card on Alipay to pay."
          ]
        },
        {
          question:
            "What's the reason for the different packaging of the products?",
          answer: [
            "Due to the frequent packaging updates of overseas manufacturers and the fast operation of product cycle of the product department, it is occasionally found that multiple batches of products in the warehouse are mixed with the old and new packaging. However, they can guarantee the authenticity and authenticity of the products, and the customers do not need to worry about the quality."
          ]
        }
      ]
    };
  },

  // 跨境商学院导航 school_subbar
  school_subbar() {
    return {
      active: 0,
      data: [
        // {
        //   url: "/en/school",
        //   name: "Cross border business school"
        // },
        {
          url: "/en/school_1",
          name: "Industry knowledge"
        },
        {
          url: "/en/school_2",
          name: "Warehousing logistics"
        },
        {
          url: "/en/school_3",
          name: "Road payment standard"
        },
        {
          url: "/en/school_4",
          name: "after-sale service"
        }
      ],
      setup(key) {
        this.active = key;
      }
    };
  },

  // about img_bg about_img_bg
  about_img_bg() {
    return {
      height: "566px",
      bg_img: "/img/bg_about.png",
      title: "About us",
      sub:
        "Financial science and technology enterprises construct innovative financial science and technology ecosystem",
      desc: [
        "MYPAY NZ is a technology driven payment company in New Zealand, providing online and offline convenience services between retailers and end customers.",
        "Our main businesses include aggregate payment, online and offline sales and payment solutions for local merchants and cross-border iemall."
      ]
    };
  },

  // about tips about_tips
  about_tips() {
    return {
      item_style: "box-shadow:0px 1px 15px 0px rgba(207,218,228,0.4);",
      list: [
        {
          ico: "/img/about/icon_new_1.png",
          size: "160px",
          title: "Our mission",
          sub: "Let people have their own business"
        },
        {
          ico: "/img/about/icon_new_2.png",
          size: "160px",
          title: "Our mission",
          sub:
            "Providing local and cross-border payment services and cross-border e-commerce solutions"
        },
        {
          ico: "/img/about/icon_new_3.png",
          size: "160px",
          title: "Key advantages",
          sub:
            "The core operation and development team provides aggregate payment and cross-border e-commerce solutions by pooling the product advantages of thousands of local merchants and brands"
        }
      ]
    };
  },

  // about step about_step
  about_step() {
    return {
      title: "Enterprise development history",
      steps: [
        {
          done: true,
          date: "May 9, 2016",
          title: "establish",
          desc:
            "Mypay New Zealand was incorporated in New Zealand on May 9, 2016 and is part of IE financial services group to take advantage of the growth of global e-commerce and the demand for integrated payment platforms in New Zealand and Australia. Its ultimate holding company is ie Financial Services Limited (iefs)."
        },
        {
          done: true,
          date: "September 2016",
          title: "Become an Alipay partner",
          desc: "MyPay New Zealand became Alipay's first New Zealand partner."
        },
        {
          done: true,
          date: "October 26, 2017",
          title: "Become wechat partner",
          desc: "Mypay New Zealand becomes wechat pay partner."
        },
        {
          done: true,
          date: "November 1, 2018",
          title: "MIE PAY Mie pay NZ founded",
          desc: "Mie pay NZ becomes the holding company of mypay NZ"
        },
        {
          done: true,
          date: "December 2018",
          title: "Green Cross",
          desc:
            "Green Cross, the largest pharmaceutical and beauty group in New Zealand, has become a mypay merchant"
        },
        {
          done: true,
          date: "December 2018",
          title: "Ieshop Online",
          desc: "Mypay NZ launches ieshop e-commerce cloud platform"
        },
        {
          done: false,
          date: "December 19, 2018",
          title: "Launch listing",
          desc:
            "Miepay limited becomes the holding company of mypay NZ and Mie pay NZ"
        },
        {
          done: false,
          date: "July 4, 2019",
          title: "Become a UnionPay partner",
          desc: "Mypay in New Zealand became a partner of UnionPay."
        },
        {
          done: false,
          date: "May 18, 2020",
          title: "list",
          desc:
            "Miepay Limited has successfully listed on the national stock exchange of Australia (NSX), becoming the first aggregate payment listed company in Australia and New Zealand (trading code MIE)"
        }
      ],
      stepFn() {
        var self = this;
        var el = document.getElementById("step");
        var span = screen.height / 2 + 300;
        var items =  el.getElementsByClassName("step-box");
      
        window.addEventListener("scroll", function() {
          var sY = window.scrollY || document.body.scrollTop;
          
          for(var i = 0; i < items.length; i++) {
            var offsetT = items[i].offsetTop - span;
            if(sY >= offsetT) {
              self.steps[i].done = true;
            } else {
              self.steps[i].done = false;
            }
          }
        });
      }
    };
  },

  // register grogress register_progress
  register_progress() {
    return {
      todo: 1,
      data: [
        {
          type: "text",
          key: 1,
          name: "essential information"
        },
        {
          type: "line"
        },
        {
          type: "text",
          key: 2,
          name: "Settlement information"
        },
        {
          type: "line"
        },
        {
          type: "text",
          key: 3,
          name: "Complete submission"
        }
      ],
      setup(todo) {
        this.todo = todo;
      },
      isLine(k) {
        return this.data[k].type == "line";
      },
      isDone(key) {
        return this.todo > key;
      }
    };
  },

  // register data register_data
  register_data() {
    return {
      active: 1,
      form_item_width: "450px",
      progress: [
        {
          type: "text",
          key: 1,
          name: "essential information"
        },
        {
          type: "text",
          key: 2,
          name: "Settlement information"
        },
        {
          type: "text",
          key: 3,
          name: "Complete submission"
        }
      ],
      form_f: [
        {
          type: "type_change",
          value: 0,
          data: ["Personal", "Business"]
        },
        {
          type: "text",
          label: "country",
          value: "China",
          placeholder: "Please enter country"
        }
      ],
      form_f_submit_txt: "next",
      form_s: [
        {
          type: "text",
          label: "Front of ID card",
          name: "id_card_img"
        },
        {
          type: "text",
          label: "Reverse side of ID card",
          name: "id_card_img_o"
        },
        {
          type: "text",
          label: "Settlement bank",
          value: "",
          name: "people_name",
          placeholder: "Name"
        },
        {
          type: "text",
          value: "",
          name: "people_bank",
          placeholder: "bank account"
        }
      ],
      form_s_submit_txt: "Submit",
      success: {
        icon: "/img/icon_success.png",
        title: "Your channel joining application has been submitted",
        sub:
          "We will review your materials and feed back the application results within three working days.",
        email: "ieFranchisee@miepay.com",
        qrcode: ""
      },
      getProgressData() {
        let arr = [];
        for (let i = 0; i < this.progress.length; i++) {
          arr.push(this.progress[i]);
          if (i != this.progress.length - 1) {
            arr.push({
              type: "divide"
            });
          }
        }
        return arr;
      },
      isProgressDone(key) {
        return this.active > key;
      },
      isSpecial(key) {
        return ["type_change"].indexOf(key) != -1;
      },
      next() {
        console.log("next");
        this.active = 2;
      },
      submit() {
        console.log(this.form_s);
        console.log("submit");
        // this.active = 3;
      }
    };
  }
};
